"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CombineLocations = void 0;

var _logs = require("../logs");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CombineLocations = /*#__PURE__*/function () {
  function CombineLocations() {
    _classCallCheck(this, CombineLocations);

    this.locations = {};
  }

  _createClass(CombineLocations, [{
    key: "getCombinedLocations",
    value: function getCombinedLocations() {
      return this.locations;
    }
  }, {
    key: "setCombinedLocations",
    value: function setCombinedLocations() {
      for (var _len = arguments.length, locationObjects = new Array(_len), _key = 0; _key < _len; _key++) {
        locationObjects[_key] = arguments[_key];
      }

      var newLocations = locationObjects.reduce(function (acc, locations) {
        if (_typeof(locations) === 'object') {
          return _objectSpread(_objectSpread({}, acc), locations);
        }

        (0, _logs.sbLog)('combineLocations methods arguments must be objects');
        return acc;
      }, {});
      this.locations = _objectSpread(_objectSpread({}, this.locations), newLocations);
    }
  }]);

  return CombineLocations;
}();

exports.CombineLocations = CombineLocations;
//# sourceMappingURL=CombineLocations.js.map